import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FlexRow } from 'src/components/layout/flex-row';
import { ButtonV2 } from '../button/lgg-button';

const FooterActionButton = styled(ButtonV2)`
  flex: 1;
  font-family: ${({ theme }) => theme.font.medium};
  font-size: 12px;
  height: 30px;
  line-height: 18px;
  padding: 6px;
`;

const FooterActionButtonContainer = styled(FlexRow)`
  border-top: 1px solid ${({ theme }) => theme.colors.koala};
  gap: 10px;
  padding: 10px;
`;

type OverlayFooterActionButtonsProps = {
  onReset: React.MouseEventHandler<HTMLButtonElement>;
  onSubmit?: React.MouseEventHandler<HTMLButtonElement>;
  baseTestId?: string;
};

export const OverlayFooterActionButtons = ({
  onReset,
  onSubmit,
  baseTestId,
}: OverlayFooterActionButtonsProps) => {
  const { t } = useTranslation(['common']);

  return (
    <FooterActionButtonContainer>
      <FooterActionButton
        variant="default"
        size="small"
        type="button"
        onClick={onReset}
        data-lgg-id={`${baseTestId}-reset-button`}
      >
        {t('common:filters.actionReset')}
      </FooterActionButton>
      <FooterActionButton
        variant="primary"
        type="submit"
        size="small"
        onClick={onSubmit}
        data-lgg-id={`${baseTestId}-save-button`}
      >
        {t('common:done')}
      </FooterActionButton>
    </FooterActionButtonContainer>
  );
};
